import { useOutsideClick } from "hooks";
import React, { useCallback, useRef, useState } from "react";
import { WithStyle } from "utils/WithStyle";
import { PopoverContext } from "./Popover.context";
import { Wrapper } from "./Popover.styled";
import Popup from "./Popup";
import { Props, StaticProps } from "./types";

export const Component: React.FC<Props> = React.memo(({ ...restProps }) => {
    const openState = useState(false),
        [, setOpenState] = openState,
        wrapperRef = useRef(null);

    const handleMouseClick = useCallback(
        () => setOpenState((val) => !val),
        [setOpenState]
    );

    useOutsideClick(wrapperRef, () => setOpenState(false));

    return (
        <PopoverContext.Provider
            value={{ isOpen: openState[0], close: () => setOpenState(false) }}
        >
            <Wrapper
                {...restProps}
                ref={wrapperRef}
                onClick={handleMouseClick}
            />
        </PopoverContext.Provider>
    );
});

Component.displayName = "Popover";
export const Popover: React.FC<Props> & WithStyle & StaticProps = Object.assign(
    Component,
    {
        Popup,
        Style: Wrapper,
        Context: PopoverContext,
    }
);
